import { SimulatorMode } from "~/models/Page"

export enum MailType {
  none = "0",
  plan = "1",
  estimate = "2"
}

export interface MailData {
  estimateId: string,
  accessTokenId: string,
  mailType: string,
  email: string,
  name: string,
  picName: string,
  pageType: SimulatorMode
  tel: string,
}
